import {
  ColumnOptionsBase,
  EntityColumn,
  entityColumn,
  GridRef,
  GroupColumnRef, isServerSideColumn,
  ServerSideColumnOption, StringColumn,
  stringColumn
} from '@softapps/core';
import { SalesOrganization } from './sales-organization';
import { Signal } from '@angular/core';
import { Translation } from '@softline/ui-core';
import { SalesOrganizationColumnComponent } from './sales-organization-column.component';

export interface ClientSideSalesOrganizationColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, SalesOrganization> {
  rowGroup?: boolean;
}

export interface ServerSideSalesOrganizationColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, SalesOrganization>, ServerSideColumnOption {
  rowGroup?: boolean;
}

export type SalesOrganizationColumnOptions<TRow extends object> = ClientSideSalesOrganizationColumnOptions<TRow> | ServerSideSalesOrganizationColumnOptions<TRow>;

export function salesOrganizationColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow>,
                                                 translator: (key: string) => Signal<Translation>,
                                                 options: SalesOrganizationColumnOptions<TRow>): StringColumn<TRow>{
  return stringColumn(ref, {
    ...options,
    getValue: o => options.getValue(o).vkforg,
    cellRenderer: undefined,
    serverSideField: (options as ServerSideColumnOption) ? `${(options as ServerSideColumnOption).serverSideField}.vkforg` : undefined,
  });
  /*return entityColumn(ref, {
    ...options,
    format: v => `${v.vkforg}`,
    sortBy: v => v.vkforg,
    cellRenderer: SalesOrganizationColumnComponent,
    serverSideSortField: 'vkforg',
  }, entityRef => {}
  );*/
}
